import { render, staticRenderFns } from "./yexam.vue?vue&type=template&id=5c2000be&scoped=true&"
import script from "./yexam.vue?vue&type=script&lang=js&"
export * from "./yexam.vue?vue&type=script&lang=js&"
import style0 from "./yexam.vue?vue&type=style&index=0&id=5c2000be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2000be",
  null
  
)

export default component.exports